import React from 'react'

import { useController, useFormContext } from 'react-hook-form'

import type { AmountInputProps } from '../InputElements'
import { AmountInput } from '../InputElements'

type ReactHookFormAmountFieldProps = Omit<
  AmountInputProps,
  'error' | 'helperText' | 'onChange' | 'value' | 'locale'
> & {
  onChange?: (name: string, value: string) => void
}

export function ReactHookFormAmountField({
  disabled,
  name,
  onChange: onChangeProp,
  ...rest
}: ReactHookFormAmountFieldProps) {
  const {
    control,
    formState: { isSubmitting },
  } = useFormContext()
  const {
    field: { onChange, value },
    fieldState: { error },
  } = useController({ name, control })

  const isFieldDisabled = disabled || isSubmitting

  const handleChange = React.useCallback(
    (inputValue: string) => {
      onChange?.(inputValue)
      onChangeProp?.(name, inputValue)
    },
    [name, onChange, onChangeProp]
  )

  return (
    <AmountInput
      disabled={isFieldDisabled}
      error={!!error}
      helperText={error?.message ?? ''}
      name={name}
      onChange={handleChange}
      value={value}
      {...rest}
    />
  )
}
